import React from 'react';

export default function BrandHero({ className = '' }) {
  return (
    <div className={`brand-hero ${className}`.trim()}>
      <img
        src="/icons/logo-wordmark.png"
        alt="MyTownly Rides"
        className="brand-hero-wordmark-img"
        style={{
          width: '100%',
          maxWidth: 240,
          height: 'auto',
          objectFit: 'contain',
          filter: 'drop-shadow(0 4px 16px rgba(0, 0, 0, 0.25))',
        }}
      />
    </div>
  );
}
